import { dayjs } from '../../src_server/common/momentExtends';
import { MessageDialog } from '../utils/MessageDialog';
import { LessonsService } from './remote/LessonsService';
import { Session } from '../utils/Session';

export class LessonServiceFront {
  async cancel(class_id: number, done: (class_id: number) => void) {
    const biz = new LessonsService();
    const lesson = (await biz.getLesson(class_id)).data;

    // キャンセル期限を開始1時間前とする
    const diff = -1;
    const diffDate = dayjs(lesson.start_dt).add(diff, 'hour').diff(dayjs(), 'minute');
    // alert(`${diffDate} ${dayjs(lesson.start_dt).add(diff, 'hour')}`);
    if (diffDate < 0) {
      await MessageDialog.alertModal('キャンセル期限を超えています。');
      return;
    }

    let reason = '';
    // DAは欠席加算時にキャンセル理由を書く

    // レッスン日引く3日の0時と現在日時を比べて+なら過ぎてない,-なら過ぎてる
    // 3日前の0時すぎるとキャンセル理由
    const today = dayjs();
    const diffLessonDate = dayjs(lesson.start_dt).add(-3, 'day').startOf('day').diff(today, 'minute');
    if (!Session.isCircleOBuilding() && diffLessonDate < 0) {
      await MessageDialog.alertModal('授業まで3日を切っているため欠席加算されます');
      const inputReason = await MessageDialog.prompt('キャンセル理由を記入ください。');
      if (!inputReason) {
        return;
      }
      reason = inputReason;
    }

    // COなら常にキャンセル理由を聞く
    if (Session.isCircleOBuilding()) {
      const inputReason = await MessageDialog.prompt('キャンセル理由を記入ください。');
      if (!inputReason) {
        return;
      }
      reason = inputReason;
    }

    const isOK = await MessageDialog.confirm(`このレッスンをキャンセルして担当者に通知します。よろしいですか？[${class_id}]`);
    if (isOK) {
      await biz.cancel(class_id, Session.getSessionBuildingId(), reason);
      await MessageDialog.alert('キャンセルしました');
      done(class_id);
    }
  }
}
